import Themes from '@lib/context/themes';
import { createContext } from 'react';

export type Theme = (typeof Themes)[keyof typeof Themes];

export type ThemeContextType = {
  theme: Theme;
  isThemeResolved: boolean;
  selectTheme: (newThemeSelection: string) => Promise<void>;
  devOverride: boolean;
  overrideThemeDetection: () => void;
};

export const ThemeContext = createContext<ThemeContextType>({
  theme: Themes.hbs,
  isThemeResolved: false,
  selectTheme: async () => {},
  devOverride: false,
  overrideThemeDetection: () => {}
});
